import React, { useState, useCallback, useRef, useEffect } from 'react'
import Layout from '../../../components/Admin/Layout'
import Loading from '../../../components/shared/Loading'

import './Returns.scss'
import InputField from '../../../components/shared/InputField'
import CustomTable from '../../../components/Admin/CustomTable'
import FileDownload from 'js-file-download'
import CustomizedBtn from '../../../components/Admin/CustomizedBtn'
import { Collapse, useEventCallback } from '@material-ui/core'
import InputDate from '../../../components/Admin/InputDate'
import CustomizeSelect from '../../../components/Admin/CustomizeSelect'
import AdminService from '../../../services/AdminServices'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SimpleModal from '../../../components/shared/MessageModal'
import moment from 'moment'
// import PropTypes from 'prop-types'

const columns = [
  { id: 'guideNumber', label: 'Guía', minWidth: 150 },
  { id: 'cud', label: 'CUD', minWidth: 120, hasPopup: true },
  { id: 'quantity', label: 'Cant', minWidth: 100 },
  { id: 'receptionDate', label: 'Fec. Recepción', minWidth: 150, format: (date) => date ? moment(date).format('DD-MM-YYYY') : date  },
  { id: 'expiredDate', label: 'Fec. Vencido', minWidth: 150, format: (date) => date ? moment(date).format('DD-MM-YYYY') : date },
  { id: 'dni', label: 'DNI Cliente', minWidth: 150, hasPopup: true },
  { id: 'place', label: 'Ubicación', minWidth: 250, cellStyle:{ justifyContent: 'flex-start'} },
  { id: 'origin', label: 'Origen', minWidth: 100 },
]

// const rows = [
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000004', ean: '2003178106032', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT LOKY' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
//   { guideNumber: '3171861434', cud: { value: '0230001710082281000003', ean: '2003178106083', descripcion: 'FUENTE CUADR 2 LT+FUENTE RECT3LT PYREX' }, quantity: 2, recepDate: '10/04/20', expDate: '30/04/20', dni: { value: 73034152, nombre: 'Carlos José Pacheco Rodríguez', correo: 'carlosjose.pachecorodriguez@gmail.com', number: '998 345 678' }, place: { value: 'Tambo pamplona', img: 'https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png' }, origin: 'Ripley' },
// ]

const Returns = props => {
  const [operatorsOption, setOperatorOpt] = useState([]);
  const [pickupPointOption, setPickupPointOpt] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [perPage, setPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [countFilters, setCountFilters] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [applyFilters, setFilters] = useState({apply: false});
  const [form, setForm] = useState({
    guideNumber: '',
    clientDni: '',
    startDate: null,
    endDate: null,
    operators: [],
    pickupPoint: [],
    // applied: false
  })
  const unmountedRef = useRef(false);
  const unmountedRef2 = useRef(false);
  const didMounRef = useRef(false);

  useEffect(() => {
    // console.log(countFilters, 'CAMBIANDO')
    loadExpiredCuds();
    // else if(!form.applied && countFilters === 0) loadExpiredCuds();
  }, [applyFilters])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if(didMounRef.current)onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
  }, [perPage]);

  const formatCuds = (cuds) => {
    return cuds.map(c => ({
      ...c,
      cud:{
        value: c.cudNumber,
        ean: c.ean,
        descripcion: c.description
      },
      // recepDate: '10/04/20',
      // expDate: '30/04/20',
      dni: { value: c.clientDni, nombre: c.clientName, correo: c.clientEmail, number: c.clientPhone },
      place: { value: c.location, img: c.logo },
      origin: 'Ripley'
    }))
  }

  const loadOperators = useEventCallback(async () => {
    const operators = await AdminService.getOperators();
    console.log(operators);
    setOperatorOpt(operators.map(o => ({
      ...o,
      value: o.id,
      label: o.name,
      img: o.image
    })));
  }, [operatorsOption])

  const loadPickUpPoints = useEventCallback(async (operators) => {
    if(operators.length <= 0) return;
    const operatorsIds = operators.map(o => o.id);
    const opertarosFormatted = operatorsIds.join(',')
    const pickupPoints = await AdminService.getPickUpPoints(opertarosFormatted);
    console.log(pickupPoints, 'PIKCUP POINTS ===>');
    setPickupPointOpt(pickupPoints.map(pp => {
      const operatorFounded = operators.find(o => o.id === pp.operatorId)
      return {
        ...pp,
        value: pp.id,
        label: pp.title,
        img: operatorFounded.img
      }
    }))
  }, [pickupPointOption])

  const loadExpiredCuds = async (perPage=5, currentPage=1) => {
    try {
      setLoading(true);
      const {total, cuds} = await AdminService.getCuds({
        ...(applyFilters.apply && {...form}),
        status:'expired',
        paginate: true,
        currentPage,
        perPage: perPage || 5
      })
      console.log(cuds);
      console.log('FORMATTED CUDS', formatCuds(cuds));
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      setRows(formatCuds(cuds));
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setModalError(true);
    }
  }

  const downloadExcel = async () => {
    try {
      setLoading(true);
      const data = await AdminService.downloadExcelCuds({
        ...(applyFilters.apply && {...form}),
      })
      FileDownload(data, 'excel_cuds_vencidos.xlsx')
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setModalError(true);
      console.error(error)
    }
  }

  useEffect(() => {
    unmountedRef2.current = false;
    return () => {
      unmountedRef2.current = true;
    };
  }, [loadPickUpPoints]);

  useEffect(() => {
    unmountedRef.current = false;
    loadOperators();
    return () => {
      unmountedRef.current = true;
    };
  }, [loadOperators]);

  useEffect(() => {
    loadExpiredCuds(perPage, currentPage)
  }, [])

  const clearForm = () => {
    setForm({
      guideNumber: '',
      clientDni: '',
      startDate: null,
      endDate: null,
      operators: [],
      pickupPoint: [],
      // applied: false
    })
    setCountFilters(0);
    // loadExpiredCuds();
  }

  const handleChange = async (evt, name) => {
    let newForm = {...form}
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    console.log(value, key);
    if(key === 'operators') {
      loadPickUpPoints(value);
      newForm.pickupPoint = [];
    }
    if(key === 'guideNumber' && (value.length > 10 || isNaN(value) )) return;
    if(key === 'clientDni' && (value.length > 8 || isNaN(value))) return;
    setForm({
      ...newForm,
      [key]: value
    })
  }

  const countFiltersFilled = () => {
    let count = Object.keys(form).length;
    console.log(count);
    for (const key in form) {
      if (form[key] === "" || form[key] === null) count -= 1
      else if(Array.isArray(form[key]) && form[key].length <= 0) count -= 1
      if (key === 'operators' && form[key].length > 0) count-=1
    }
    return count;
  }

  const handleFilters = async () => {
    setOpenForm(false);
    const count = countFiltersFilled();
    setCountFilters(count);
    // setForm({...form, applied: true})
    setPerPage(5);
    setCurrentPage(1);
    setFilters({apply:true});
  }

  const clearFilters = () => {
    setOpenForm(false);
    clearForm();
    setPerPage(5);
    setCurrentPage(1);
    setFilters({apply:false});
  }

  const onChangePerPage = async (perPage) => {
    if(perPage <= 0) return;
    setCurrentPage(1);
    await loadExpiredCuds(perPage, 1)
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    loadExpiredCuds(perPage, numPage)
  }

  return (
    <Layout>
      <SimpleModal
        visible={modalError}
        type={1}
        closeModal={() => setModalError(false)}
        message={'Ha ocurrido un error al conectar con el servidor, porfavor intente nuevamente o mas tarde.'}
      />
      <div className='returns-container'>
        <Loading visible={loading} />
        <div className='returns-title'>Devolución de Pedidos</div>
        <div className='returns-filters'>
          <div className='returns-filters-header'>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span className='returns-label-bold'>Filtros</span>
              <span className='returns-filters-header-subtitle'>{countFilters} filtros aplicados</span>
            </div>
            {
              !openForm
                ? <ExpandMoreIcon onClick={()=>setOpenForm(true)} fontSize='large' style={{color: '#FF6868', cursor:'pointer'}}/>
                : <ExpandLessIcon onClick={()=>setOpenForm(false)} fontSize='large' style={{color: '#FF6868', cursor:'pointer'}}/>
            }
          </div>
          <Collapse in={openForm}>
            <form className='returns-form'>
              <div className='returns-form-field small'>
                <InputField
                  name='guideNumber'
                  value={form.guideNumber}
                  handleChange={handleChange}
                  label='Guía'
                  fullWidth
                  inputType='textfield'
                />
              </div>
              <div className='returns-form-field small'>
                <InputField
                  name='clientDni'
                  value={form.clientDni}
                  handleChange={handleChange}
                  label='DNI Cliente'
                  fullWidth
                  inputType='textfield'
                />
              </div>
              <div className='returns-form-field small'>
                <InputDate
                  value={form.startDate}
                  handleChange={(e) => handleChange(e, 'startDate')}
                  label='Fec. Vencimiento (Inicio)'
                  fullWidth
                />
              </div>
              <div className='returns-form-field small'>
                <InputDate
                  value={form.endDate}
                  handleChange={(e) => handleChange(e, 'endDate')}
                  label='Fec. Vencimiento (Final)'
                  fullWidth
                  disabled={!form.startDate}
                  minDate={form.startDate}
                  minDateMessage='La fecha final debe ser despues del inicio'
                />
              </div>
              <div className='returns-form-field'>
                <CustomizeSelect
                  label='Operadores de retiro'
                  name='operators'
                  value={form.operators}
                  handleChange={(e, value) => handleChange(value, 'operators')}
                  multiple={true}
                  noMargin
                  checkbox
                  options={operatorsOption}
                />
              </div>
              <div className='returns-form-field'>
                <CustomizeSelect
                  label='Puntos de retiro'
                  name='pickupPoint'
                  value={form.pickupPoint}
                  handleChange={(e, value) => handleChange(value, 'pickupPoint')}
                  // handleChange={handleChange}
                  multiple={true}
                  noMargin
                  checkbox
                  countSelected
                  disabled={!form.operators.length}
                  options={pickupPointOption}
                />
              </div>
              <div className='returns-form-footer'>
                <CustomizedBtn
                  margin='0'
                  outline={false}
                  // disabled={!form.email || !form.file}
                  padding='1em'
                  onClick={clearFilters}
                  size='medium'>
                  <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Limpiar filtros</span>
                </CustomizedBtn>
                <CustomizedBtn
                  filled
                  margin='0'
                  // disabled={!form.email || !form.file}
                  padding='1em'
                  onClick={handleFilters}
                  disabled={countFiltersFilled() <= 0}
                  size='medium'>
                  <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Aplicar filtros</span>
                </CustomizedBtn>
              </div>
            </form>
          </Collapse>
        </div>
        <div className='returns-report-header'>
          <span className='returns-label-bold'>Reporte</span>
          <CustomizedBtn
            filled
            margin='0'
            // disabled={!form.email || !form.file}
            padding='1em'
            onClick={downloadExcel}
            size='medium'
          >
            <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Exportar a Excel</span>
          </CustomizedBtn>
        </div>
        <div className='returns-report'>
          <CustomTable
            columns={columns}
            rows={rows}
            // onChangeNumElem={(num) => onChangePerPage(num)}
            total={total}
            currentPage={currentPage}
            changePage={onChangePage}
            perPage={perPage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
            totalPages={totalPages}
          />
        </div>
      </div>
    </Layout>
  )
}

Returns.propTypes = {

}

export default Returns
